
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2849',
  depVersions: {
  "customer-portal-app": "static-1.2849",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.488",
  "data-fetching-client": "static-1.9830",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25906",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5766",
  "hs-test-utils": "static-1.8194",
  "hub-http": "static-1.6392",
  "hub-http-shared-msw-handlers": "static-1.10394",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18742",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11649",
  "I18n": "static-7.1645",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6628",
  "payment-link-components": "static-1.23909",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7258",
  "quartz-core": "static-1.6477",
  "quartz-i18n": "static-1.933",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10380",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5465",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20133",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18219",
  "ui-components-test-utils": "static-1.5786",
  "UIComponents": "static-3.8595",
  "foundations-assets": "static-1.5046",
  "foundations-components": "static-1.8272",
  "foundations-theming": "static-1.4611",
  "foundations-theming-specialty": "static-1.2327",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1238",
  "quartz-config": "static-1.1036",
  "quartz-routing": "static-1.688",
  "quick-fetch": "static-1.4041",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16872",
  "rpc-client-utils": "static-1.4830",
  "sanitize-text": "static-1.8318",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4930",
  "ui-addon-react-router-dom": "static-1.9706",
  "usage-tracker": "static-1.7524",
  "usage-tracker-anonymous": "static-1.5941",
  "usage-tracker-core": "static-1.7374",
  "video-components-external": "static-1.11856",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3525",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3535",
  "quartz-webpack": "static-1.3482",
  "bend-plugin-quartz-routing": "static-1.336",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7852",
  "frontend-preferences-client": "static-1.8100",
  "laboratory-lib": "static-3.7324",
  "onboarding-scopes": "static-1.6631",
  "seat-types-lib": "static-1.408",
  "ui-addon-opt": "static-4.8533",
  "HeadJS": "static-2.777",
  "hs-test-utils-bend-plugin": "static-1.3305",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.206",
  "ts-schema": "static-1.4205",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8020",
  "content-media-capture": "static-1.5079",
  "cssUtils": "static-1.842",
  "customer-data-ui-utilities": "static-1.9997",
  "file-manager-components": "static-1.24136",
  "HubStyle": "static-2.11956",
  "knowledge-content-types": "static-1.8584",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10056",
  "ui-addon-i18n": "static-1.11321",
  "ui-business-units-lib": "static-1.9252",
  "ui-shepherd-react": "static-3.10434",
  "video-data-lib": "static-1.35514",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4496",
  "commerce-tours-lib": "static-1.6429",
  "customer-data-properties": "static-1.52169",
  "getting-started-shared-tasks": "static-1.18932",
  "growth-onboarding-reliability": "static-1.5255",
  "onboarding-tours": "static-1.16929",
  "reference-resolvers-lite": "static-1.8269",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9248",
  "user-context": "static-1.5283",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.852",
  "hubspotter-http": "static-1.4775",
  "icons": "static-2.665",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.933",
  "quartz-head": "static-1.923",
  "quartz-test": "static-1.933",
  "quartz-tracking": "static-1.637",
  "trellis-components": "static-1.2298",
  "ui-fonts": "static-1.911",
  "usage-tracker-container": "static-1.7514",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9598",
  "data-token-picker": "static-1.16715",
  "FileManagerLib": "static-1.39776",
  "property-translator": "static-1.5566",
  "atom": "static-1.5248",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6169",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5755",
  "react-create-root-preference": "static-1.45",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1205",
  "bend-plugin-foundations-components": "static-1.4541",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2279",
  "bend-plugin-foundations-theming": "static-1.3094",
  "foundations-theming-base": "static-1.3596",
  "stylex": "static-1.37",
  "interframe": "static-3.4928",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5938",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.240",
  "chirp-fetch": "static-1.2060",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4649",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4824",
  "content-media-composition-data-lib": "static-1.12883",
  "content-media-compositions": "static-2.16890",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4321",
  "magpie-lib": "static-1.5666",
  "magpie-types": "static-1.5126",
  "media-bridge-lib": "static-1.19229",
  "bender-build-tools": "static-1.3301",
  "inbound-db-properties-service-client": "static-1.3970",
  "superstore": "static-1.4930",
  "feedback-loader": "static-1.29622",
  "ai-components-ui-library": "static-1.9396",
  "ui-addon-video-player": "static-1.8877",
  "ui-coaching-tips": "static-1.29053",
  "ContentUtils": "static-1.68883",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4598",
  "sassPrefix": "static-1.159",
  "react-dnd-compat": "static-1.4787",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1339",
  "copilot-toolkit": "static-1.11581",
  "avatar-components": "static-1.2671",
  "navigation-messaging": "static-1.7819",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8348",
  "commerce-products-lib": "static-1.10214",
  "crm-message-bus": "static-1.43482",
  "growth-data-modal": "static-1.5713",
  "hubspot-apollo-client": "static-1.5050",
  "onboarding-tours-client": "static-1.5143",
  "calling-global-api": "static-1.65104",
  "calling-internal-common": "static-1.31485",
  "calling-lifecycle-internal": "static-1.66486",
  "calling-lifecycle-messages": "static-1.58780",
  "conditional-properties-service-client": "static-1.3922",
  "crm-links": "static-1.6487",
  "crm-pipelines-api-client-types": "static-1.4262",
  "customer-data-objects-ui-components": "static-1.13202",
  "customer-data-properties-shared-msw-handlers": "static-1.9721",
  "customer-data-property-utils": "static-1.8268",
  "external-options-client-types": "static-1.4251",
  "formula-editor": "static-1.14564",
  "framework-data-schema-resolvers": "static-1.7066",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.350",
  "inbound-db-meta-service-client": "static-1.3712",
  "inbounddb-objects-service-types": "static-1.4341",
  "meetings-icalendar-utils-lib": "static-1.804",
  "multi-currency-client-types": "static-1.3816",
  "object-builder-ui-client": "static-1.49315",
  "pipeline-validation-client-types": "static-1.4091",
  "property-value-citations": "static-1.2783",
  "pulse": "static-1.785",
  "smart-property-lib": "static-1.8053",
  "tiered-pricing": "static-1.1708",
  "topics-actions-lib": "static-1.320",
  "ui-addon-form-validation": "static-1.11162",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3236",
  "growth-onboarding-next-action-utils": "static-1.2431",
  "navigation-components": "static-1.18492",
  "onboarding-tours-utils": "static-1.995",
  "ui-shepherd-tracker": "static-1.7815",
  "ui-universal-auth": "static-1.9182",
  "batch-promise": "static-1.1717",
  "getting-started-shared-tasks-store": "static-1.18050",
  "hubspotter-http-shared-msw-handlers": "static-1.10392",
  "usage-tracker-session-replay": "static-1.5210",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1121",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6176",
  "FileManagerCore": "static-1.39635",
  "FileManagerImages": "static-1.37287",
  "video-components": "static-1.13858",
  "foundations-components-legacy": "static-1.1297",
  "purchase-motions-api": "static-1.6172",
  "signup-constants": "static-1.19303",
  "signup-ui-url-generator": "static-2.8231",
  "usage-tracker-public": "static-1.7335",
  "reactive-lib": "static-1.897",
  "simple-logging-lib": "static-1.3221",
  "chatspot-core": "static-1.22183",
  "growth-onboarding-feedback-components": "static-1.6751",
  "cms-field-types": "static-1.4987",
  "content-icons-ui": "static-1.2278",
  "integrations-lib": "static-1.16713",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.617",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.948",
  "customer-data-tracking": "static-1.7057",
  "products-iframe-lib": "static-1.8355",
  "products-ui-components-shared-msw-handlers": "static-1.10776",
  "restore-request-side-panel-lib": "static-1.1359",
  "onboarding-data-sync-lib": "static-1.2261",
  "hubspot-apollo-cache": "static-1.509",
  "calling-error-reporting": "static-1.31492",
  "shared-worker-versioning": "static-1.11209",
  "calling-usage-tracker": "static-1.6713",
  "voice-sms-access-library": "static-1.1626",
  "conversations-skeleton-state": "static-1.7421",
  "location-customization-utils-lib": "static-1.9773",
  "bark-lib": "static-1.16654",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6059",
  "react-codemirror": "static-1.10805",
  "fdsr-migration-layer": "static-1.185",
  "framework-builder-read-service-client": "static-1.4130",
  "framework-data-schema-quick-fetch": "static-1.6971",
  "persist-promise": "static-1.3874",
  "event-emitter": "static-1.1122",
  "bend-plugin-pulse": "static-1.288",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.469",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10477",
  "fsm": "static-1.3902",
  "policy-lib": "static-1.6957",
  "react-tinymce": "static-1.55713",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10540",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54839",
  "tinymce-plugins": "static-1.57953",
  "tinymce-themes": "static-1.56809",
  "growth-onboarding-next-action-components": "static-1.2459",
  "user-context-client": "static-1.4722",
  "nest": "static-1.406",
  "unified-auth-core-lib": "static-1.978",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4704",
  "video-embed": "static-1.36348",
  "social-insights-client-types": "static-1.22538",
  "flux-actions": "static-1.352",
  "integrations-error-boundary-lib": "static-1.14128",
  "integrations-tracking-lib": "static-1.5779",
  "native-integrations-shared-strings": "static-1.7952",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10536",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.696",
  "sales-views-client-types": "static-1.4430",
  "InboxConnectUtils": "static-4.15287",
  "meetings-connect-utils-lib": "static-1.7779",
  "calling-orchestration-schema": "static-1.36403",
  "crm-record-cards-service-types": "static-1.3709",
  "react-reducer-toolkit": "static-1.16085",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4679",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3215",
  "tinymce-data": "static-1.40924",
  "ui-addon-sales-email": "static-1.5384",
  "layout-dnd-components": "static-1.12780",
  "layout-dnd-utils": "static-1.11755",
  "ui-brand-identity-lib": "static-1.15923",
  "NamespacedHubStyle": "static-2.9176",
  "outpost": "static-1.4340",
  "universal-page-editor-lib": "static-1.3185",
  "adobe-sign-auth-lib": "static-1.195",
  "ads-unified-auth-lib": "static-1.682",
  "google-sheets-integration-lib": "static-1.759",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.210",
  "slack-ui-library": "static-1.10569",
  "ContentData": "static-1.68958",
  "layout-data-lib": "static-1.10080",
  "advanced-menus-core": "static-1.15416",
  "advanced-menus-lib": "static-1.12313",
  "ExportDialog": "static-6.10550",
  "ui-memberships-settings-lib": "static-1.34526",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15415",
  "simple-menus-lib": "static-1.16932"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2849",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.488",
  "data-fetching-client": "/data-fetching-client/static-1.9830",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25906",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5766",
  "hs-test-utils": "/hs-test-utils/static-1.8194",
  "hub-http": "/hub-http/static-1.6392",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10394",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18742",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11649",
  "I18n": "/I18n/static-7.1645",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6628",
  "payment-link-components": "/payment-link-components/static-1.23909",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7258",
  "quartz-core": "/quartz-core/static-1.6477",
  "quartz-i18n": "/quartz-i18n/static-1.933",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10380",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5465",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20133",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18219",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5786",
  "UIComponents": "/UIComponents/static-3.8595",
  "foundations-assets": "/foundations-assets/static-1.5046",
  "foundations-components": "/foundations-components/static-1.8272",
  "foundations-theming": "/foundations-theming/static-1.4611",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2327",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1238",
  "quartz-config": "/quartz-config/static-1.1036",
  "quartz-routing": "/quartz-routing/static-1.688",
  "quick-fetch": "/quick-fetch/static-1.4041",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16872",
  "rpc-client-utils": "/rpc-client-utils/static-1.4830",
  "sanitize-text": "/sanitize-text/static-1.8318",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4930",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9706",
  "usage-tracker": "/usage-tracker/static-1.7524",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5941",
  "usage-tracker-core": "/usage-tracker-core/static-1.7374",
  "video-components-external": "/video-components-external/static-1.11856",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3525",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3535",
  "quartz-webpack": "/quartz-webpack/static-1.3482",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.336",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7852",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8100",
  "laboratory-lib": "/laboratory-lib/static-3.7324",
  "onboarding-scopes": "/onboarding-scopes/static-1.6631",
  "seat-types-lib": "/seat-types-lib/static-1.408",
  "ui-addon-opt": "/ui-addon-opt/static-4.8533",
  "HeadJS": "/HeadJS/static-2.777",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3305",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.206",
  "ts-schema": "/ts-schema/static-1.4205",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8020",
  "content-media-capture": "/content-media-capture/static-1.5079",
  "cssUtils": "/cssUtils/static-1.842",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9997",
  "file-manager-components": "/file-manager-components/static-1.24136",
  "HubStyle": "/HubStyle/static-2.11956",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10056",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11321",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9252",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10434",
  "video-data-lib": "/video-data-lib/static-1.35514",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4496",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6429",
  "customer-data-properties": "/customer-data-properties/static-1.52169",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18932",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5255",
  "onboarding-tours": "/onboarding-tours/static-1.16929",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8269",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9248",
  "user-context": "/user-context/static-1.5283",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.852",
  "hubspotter-http": "/hubspotter-http/static-1.4775",
  "icons": "/icons/static-2.665",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.933",
  "quartz-head": "/quartz-head/static-1.923",
  "quartz-test": "/quartz-test/static-1.933",
  "quartz-tracking": "/quartz-tracking/static-1.637",
  "trellis-components": "/trellis-components/static-1.2298",
  "ui-fonts": "/ui-fonts/static-1.911",
  "usage-tracker-container": "/usage-tracker-container/static-1.7514",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9598",
  "data-token-picker": "/data-token-picker/static-1.16715",
  "FileManagerLib": "/FileManagerLib/static-1.39776",
  "property-translator": "/property-translator/static-1.5566",
  "atom": "/atom/static-1.5248",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6169",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5755",
  "react-create-root-preference": "/react-create-root-preference/static-1.45",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1205",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4541",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2279",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3094",
  "foundations-theming-base": "/foundations-theming-base/static-1.3596",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4928",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5938",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.240",
  "chirp-fetch": "/chirp-fetch/static-1.2060",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4649",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4824",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12883",
  "content-media-compositions": "/content-media-compositions/static-2.16890",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4321",
  "magpie-lib": "/magpie-lib/static-1.5666",
  "magpie-types": "/magpie-types/static-1.5126",
  "media-bridge-lib": "/media-bridge-lib/static-1.19229",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3970",
  "superstore": "/superstore/static-1.4930",
  "feedback-loader": "/feedback-loader/static-1.29622",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9396",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8877",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29053",
  "ContentUtils": "/ContentUtils/static-1.68883",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4598",
  "sassPrefix": "/sassPrefix/static-1.159",
  "react-dnd-compat": "/react-dnd-compat/static-1.4787",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1339",
  "copilot-toolkit": "/copilot-toolkit/static-1.11581",
  "avatar-components": "/avatar-components/static-1.2671",
  "navigation-messaging": "/navigation-messaging/static-1.7819",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8348",
  "commerce-products-lib": "/commerce-products-lib/static-1.10214",
  "crm-message-bus": "/crm-message-bus/static-1.43482",
  "growth-data-modal": "/growth-data-modal/static-1.5713",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5050",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5143",
  "calling-global-api": "/calling-global-api/static-1.65104",
  "calling-internal-common": "/calling-internal-common/static-1.31485",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66486",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58780",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3922",
  "crm-links": "/crm-links/static-1.6487",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4262",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13202",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9721",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8268",
  "external-options-client-types": "/external-options-client-types/static-1.4251",
  "formula-editor": "/formula-editor/static-1.14564",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7066",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.350",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3712",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4341",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.804",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3816",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49315",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4091",
  "property-value-citations": "/property-value-citations/static-1.2783",
  "pulse": "/pulse/static-1.785",
  "smart-property-lib": "/smart-property-lib/static-1.8053",
  "tiered-pricing": "/tiered-pricing/static-1.1708",
  "topics-actions-lib": "/topics-actions-lib/static-1.320",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11162",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3236",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2431",
  "navigation-components": "/navigation-components/static-1.18492",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.995",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7815",
  "ui-universal-auth": "/ui-universal-auth/static-1.9182",
  "batch-promise": "/batch-promise/static-1.1717",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18050",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10392",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5210",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1121",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6176",
  "FileManagerCore": "/FileManagerCore/static-1.39635",
  "FileManagerImages": "/FileManagerImages/static-1.37287",
  "video-components": "/video-components/static-1.13858",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1297",
  "purchase-motions-api": "/purchase-motions-api/static-1.6172",
  "signup-constants": "/signup-constants/static-1.19303",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8231",
  "usage-tracker-public": "/usage-tracker-public/static-1.7335",
  "reactive-lib": "/reactive-lib/static-1.897",
  "simple-logging-lib": "/simple-logging-lib/static-1.3221",
  "chatspot-core": "/chatspot-core/static-1.22183",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6751",
  "cms-field-types": "/cms-field-types/static-1.4987",
  "content-icons-ui": "/content-icons-ui/static-1.2278",
  "integrations-lib": "/integrations-lib/static-1.16713",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.617",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.948",
  "customer-data-tracking": "/customer-data-tracking/static-1.7057",
  "products-iframe-lib": "/products-iframe-lib/static-1.8355",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10776",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1359",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2261",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.509",
  "calling-error-reporting": "/calling-error-reporting/static-1.31492",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11209",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6713",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1626",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7421",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9773",
  "bark-lib": "/bark-lib/static-1.16654",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6059",
  "react-codemirror": "/react-codemirror/static-1.10805",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.185",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4130",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6971",
  "persist-promise": "/persist-promise/static-1.3874",
  "event-emitter": "/event-emitter/static-1.1122",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.288",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.469",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10477",
  "fsm": "/fsm/static-1.3902",
  "policy-lib": "/policy-lib/static-1.6957",
  "react-tinymce": "/react-tinymce/static-1.55713",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10540",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54839",
  "tinymce-plugins": "/tinymce-plugins/static-1.57953",
  "tinymce-themes": "/tinymce-themes/static-1.56809",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2459",
  "user-context-client": "/user-context-client/static-1.4722",
  "nest": "/nest/static-1.406",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.978",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4704",
  "video-embed": "/video-embed/static-1.36348",
  "social-insights-client-types": "/social-insights-client-types/static-1.22538",
  "flux-actions": "/flux-actions/static-1.352",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14128",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5779",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7952",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10536",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.696",
  "sales-views-client-types": "/sales-views-client-types/static-1.4430",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15287",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7779",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36403",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3709",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16085",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4679",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3215",
  "tinymce-data": "/tinymce-data/static-1.40924",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5384",
  "layout-dnd-components": "/layout-dnd-components/static-1.12780",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11755",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15923",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9176",
  "outpost": "/outpost/static-1.4340",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3185",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.195",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.682",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.759",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.210",
  "slack-ui-library": "/slack-ui-library/static-1.10569",
  "ContentData": "/ContentData/static-1.68958",
  "layout-data-lib": "/layout-data-lib/static-1.10080",
  "advanced-menus-core": "/advanced-menus-core/static-1.15416",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12313",
  "ExportDialog": "/ExportDialog/static-6.10550",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34526",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15415",
  "simple-menus-lib": "/simple-menus-lib/static-1.16932"
}
};
